import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import OrderPage from './pages/OrderPage';
import PickupPage from './pages/PickupPage';
import DriverDay from './pages/DriverDay';

const CLIENTS = 'https://clients.nexolog.co.il';

function RedirectToOps() {
  if (typeof window !== 'undefined') window.location.replace(CLIENTS);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 text-nexolog-navy">
      מעביר לדשבורד התפעול…
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/o/:token" element={<OrderPage />} />
        <Route path="/p/:token" element={<PickupPage />} />
        <Route path="/d/:token" element={<DriverDay />} />
        <Route path="/login" element={<RedirectToOps />} />
        <Route path="/" element={<RedirectToOps />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
